/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {AlertController, NavParams} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";

//和dialing下级返点编辑样式一致
@Component({
    templateUrl: 'agentAutoRegNew.html',
    selector: 'agent-auto-reg-edit-page',
})
export class AgentAutoRegNewPage {
    pointssc: number = 0.0;
    point115: number = 0.0;
    pointdp: number = 0.0;
    selssc: any = [];
    sel115: any = [];
    seldp: any = [];

    constructor(private navParams: NavParams, private alertCtrl: AlertController, private userService: UserService) {
        let data = navParams.get("initData");
        this.selssc = data["pointssc"];
        // this.sel115 = data["point115"];
        // this.seldp = data["pointdp"];
    }

    submitFn() {
        let requestData: any = {
            rpointssc: this.pointssc,
            // rpoint115: this.point115,
            // rpointdp: this.pointdp
        };

        this.userService.agentAutoRegNew(requestData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: "Tạo liên kết thành công."
                });
                this.pointssc = 0.0;
                // this.point115 = 0.0;
                // this.pointdp = 0.0;
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/agentAutoRegNew/agentAutoRegNew.ts